module.exports = __webpack_public_path__ + "static/img/142.3b9d2ba2.gif";